// 管理者アカウントのURL一覧
export const admAccounts = [
  '/adm/accounts',
  '/adm/account/regist',
  '/adm/account/edit/:id',
  '/adm/account/detail/:id',
];

// プログラムファイルのURL一覧
export const programFiles = [
  '/srv/files',
  '/srv/version/edit/:id',
  '/srv/version/detail/:id',
  '/srv/settings',
  '/srv/setting/regist',
  '/srv/setting/edit/:id',
  '/srv/setting/detail/:id',
];

// パンくずリスト一覧
export const breadcrumbList = {
  '/adm/accounts': {
    'Admin list': '/adm/accounts',
    'List': '',
  },
  '/adm/account/regist': {
    'Admin list': '/adm/accounts',
    'Add': '',
  },
  '/adm/account/edit/:id': {
    'Admin list': '/adm/accounts',
    '%s': '/adm/account/detail/%s',
    'Edit': '',
  },
  '/adm/account/detail/:id': {
    'Admin list': '/adm/accounts',
    '%s': '/adm/account/detail/%s',
    'Detail': '',
  },
  '/srv/files': {
    'Program File List': '/srv/files',
    'List': '',
  },
  '/srv/version/edit/:id': {
    'Program File List': '/srv/files',
    '%s': '/srv/version/detail/%s',
    'Edit': '',
  },
  '/srv/version/detail/:id': {
    'Program File List': '/srv/files',
    '%s': '/srv/version/detail/%s',
  },
  '/srv/settings': {
    'Custom Prog List': '/srv/settings',
    'List': '',
  },
  '/srv/setting/regist': {
    'Custom Prog List': '/srv/settings',
    'Add': '',
  },
  '/srv/setting/edit/:id': {
    'Custom Prog List': '/srv/settings',
    '%s': '/srv/setting/detail/%s',
    'Edit': '',
  },
  '/srv/setting/detail/:id': {
    'Custom Prog List': '/srv/settings',
    '%s': '/srv/setting/detail/%s',
  },
};

// 公開非公開
export const openStatus = {
  true: 'Opend',
  false: 'Closed'
};

// 有効無効
export const validType = {
  false: 'Disabled',
  true: 'Enabled',
};